module.exports = __webpack_public_path__ + "static/media/GalleryImage01.09c996e3.jpg";